export const WALLET_CANCEL_MESSAGE_LIMIT = 200;

const WALLET_CLOSE_EVENTS: Record<string, 'googlepay_syscheeckout_closed' | 'applepay_syscheeckout_closed'> = {
  google_pay: 'googlepay_syscheeckout_closed',
  apple_pay: 'applepay_syscheeckout_closed',
};

export function walletCloseEvent(
  paymentMethodType: string | null,
): 'googlepay_syscheeckout_closed' | 'applepay_syscheeckout_closed' | null {
  return paymentMethodType ? WALLET_CLOSE_EVENTS[paymentMethodType] ?? null : null;
}

interface WalletCancelPayload {
  status?: unknown;
  statusCode?: unknown;
  errorCode?: unknown;
  error?: unknown;
  message?: unknown;
}

const USER_CANCEL_PATTERN = /cancel|abort|dismiss|closed_by_user/i;
const ERROR_PATTERN = /error|fail|declin|reject|unavailable/i;

function readText(value: unknown): string {
  if (typeof value === 'string') {
    return value;
  }

  return typeof value === 'number' || typeof value === 'boolean' ? String(value) : '';
}

function readNested(payload: unknown): WalletCancelPayload {
  const data = (payload ?? {}) as WalletCancelPayload;

  return (typeof data.error === 'object' && data.error ? data.error : {}) as WalletCancelPayload;
}

function readMessage(payload: unknown): string {
  const data = (payload ?? {}) as WalletCancelPayload;

  return readText(data.message) || readText(readNested(payload).message);
}

function collectSignals(payload: unknown): string[] {
  const data = (payload ?? {}) as WalletCancelPayload;
  const nested = readNested(payload);

  return [
    readText(data.status),
    readText(data.statusCode),
    readText(data.errorCode),
    readText(data.message),
    readText(data.error),
    readText(nested.status),
    readText(nested.statusCode),
    readText(nested.errorCode),
    readText(nested.message),
  ].filter(Boolean);
}

export function resolveWalletCancelReason(payload: unknown): 'user' | 'error' | 'unknown' {
  const data = (payload ?? {}) as WalletCancelPayload;
  const signals = collectSignals(payload);

  if (signals.some(signal => USER_CANCEL_PATTERN.test(signal))) {
    return 'user';
  }

  const hasErrorField = Boolean(data.error || data.errorCode || readNested(payload).errorCode);

  if (hasErrorField || readMessage(payload) || signals.some(signal => ERROR_PATTERN.test(signal))) {
    return 'error';
  }

  return 'unknown';
}

export function extractWalletCancelMessage(payload: unknown): string {
  const message = readMessage(payload)
    || collectSignals(payload).find(signal => !USER_CANCEL_PATTERN.test(signal))
    || 'wallet closed without payment';

  return message.slice(0, WALLET_CANCEL_MESSAGE_LIMIT);
}
